module.exports = {
  'strategy-consulting': require('./StrategyConsultingPage'),
  'business-optimization': require('./BusinessOptimizationPage'),
  'technology-strategy': require('./TechnologyStrategyPage'),
  'technology-assessment': require('./TechnologyAssessmentPage'),
  'product-strategy': require('./ProductStrategyPage'),
  'product-innovation': require('./ProductInnovationPage'),
  'design-thinking': require('./DesignThinkingPage'),
  'mvp-development': require('./MvpDevelopmentPage'),
  'user-experience': require('./UserExperiencePage'),
  'software-development': require('./SoftwareDevelopmentPage'),
  'web-app-development': require('./WebAppDevelopmentPage'),
  'mobile-app-development': require('./MobileAppDevelopmentPage'),
  'enterprise-architecture': require('./EnterpriseArchitecturePage'),
  'platform-refactoring': require('./PlatformRefactoringPage'),
  'agile-development': require('./AgileDevelopmentPage'),
  'product-engineering': require('./ProductEngineeringPage'),
  'nearshore-development': require('./NearshoreDevelopmentPage'),
  'offshore-development': require('./OffshoreDevelopmentPage'),
  'cloud-services': require('./CloudServicesPage'),
  'cloud-consulting': require('./CloudConsultingPage'),
  'managed-cloud-finops': require('./ManagedCloudFinopsPage'),
  'cloud-native-engineering': require('./CloudNativeEngineeringPage'),
  'cloud-migration': require('./CloudMigrationPage'),
  'modernization': require('./ModernizationPage'),
  'digital-delivery': require('./DigitalDeliveryPage'),
  'program-management': require('./ProgramManagementPage'),
  'managed-services': require('./ManagedServicesPage'),
  'learning-development': require('./LearningDevelopmentPage'),
  'advanced-technology': require('./AdvancedTechnologyPage'),
  'robotic-process-automation': require('./RoboticProcessAutomationPage'),
  'business-process-orchestration': require('./BusinessProcessOrchestrationPage'),
  'internet-of-things': require('./InternetOfThingsPage'),
  'blockchain': require('./BlockchainPage'),
  'ar-vr': require('./ArVrPage'),
  'quality-assurance': require('./QualityAssurancePage'),
  'functional-testing': require('./FunctionalTestingPage'),
  'integration-testing': require('./IntegrationTestingPage'),
  'automation-testing': require('./AutomationTestingPage'),
  'self-healing-test-automation': require('./SelfHealingTestAutomationPage'),
  'data-services': require('./DataServicesPage'),
  'data-strategy': require('./DataStrategyPage'),
  'data-engineering': require('./DataEngineeringPage'),
  'data-aggregation': require('./DataAggregationPage'),
  'data-governance': require('./DataGovernancePage'),
  'privacy-security': require('./PrivacySecurityPage'),
  'governance-risk-compliance': require('./GovernanceRiskCompliancePage'),
  'cyber-security': require('./CyberSecurityPage'),
  'security-consulting': require('./SecurityConsultingPage'),
  'penetration-testing': require('./PenetrationTestingPage'),
};
